import { render, staticRenderFns } from "./LookDialog.vue?vue&type=template&id=c5f34254&scoped=true"
import script from "./LookDialog.vue?vue&type=script&lang=js"
export * from "./LookDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f34254",
  null
  
)

export default component.exports